import { Link } from "react-router-dom";
import { Newspaper, Mail } from "lucide-react";
import Seo from "../lib/seo";
import PageHeader from "../components/PageHeader";
import { CONTACT } from "../lib/constants";

const ComingSoon = ({ overline, title, subtitle, kind, testid }) => (
    <>
        <Seo title={title} description={subtitle} path={`/${kind}`} />
        <PageHeader overline={overline} title={title} subtitle={subtitle} />
        <section className="bg-editorial py-24 md:py-32" data-testid={testid}>
            <div className="max-w-[800px] mx-auto px-6 lg:px-10 text-center">
                <Newspaper className="w-12 h-12 text-coral mx-auto mb-6" />
                <h2 className="font-serif text-3xl md:text-4xl text-navy-900 mb-4">Coming Soon</h2>
                <p className="text-lg text-navy-800/75 mb-10 leading-relaxed">
                    {kind === "press"
                        ? "Press releases, media kits, and recent coverage of the JC Law Foundation will be published here as our advocacy efforts expand."
                        : "Stories, awareness updates, and educational content are on the way. Check back soon as we share lessons, milestones, and resources from the front lines of CPR & AED advocacy."}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <a href={`mailto:${kind === "press" ? CONTACT.press : CONTACT.general}`} className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-navy-900 text-editorial hover:bg-navy-800 transition-colors">
                        <Mail className="w-4 h-4" /> {kind === "press" ? "Media Inquiries" : "Be the first to know"}
                    </a>
                    <Link to="/" className="px-7 py-3.5 border border-navy-900 hover:bg-navy-900 hover:text-editorial transition-colors">
                        Back to Home
                    </Link>
                </div>
            </div>
        </section>
    </>
);

export const PressPage = () => (
    <ComingSoon
        overline="Press & Media"
        title="Press & Media"
        subtitle="For media inquiries, interviews with our founder, or press kits, please reach out to press@jclawsc.org."
        kind="press"
        testid="press-page"
    />
);

export const BlogPage = () => (
    <ComingSoon
        overline="Blog & News Updates"
        title="From the Foundation"
        subtitle="Stories, awareness updates, and educational content from the JC Law Foundation."
        kind="blog"
        testid="blog-page"
    />
);

export default PressPage;
